import { render, staticRenderFns } from "./superSearchNumber.vue?vue&type=template&id=466ab45f&"
import script from "./superSearchNumber.vue?vue&type=script&lang=js&"
export * from "./superSearchNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/list/superSearch/superSearchNumber.vue"
export default component.exports